import { CSSProperties } from "@material-ui/core/styles/withStyles";

// constants
import { CALENDAR_HEIGHT } from "../Calendar.constants";

// styles
import { colors, greys } from "@styles/color.styles";
import { fontFamily, fontFamilySans } from "@styles/type.styles";

const container: CSSProperties = {
  position: "relative",
  flex: 1,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  padding: "24px 0 24px 12px",
  minHeight: CALENDAR_HEIGHT,

  "& .calendar-container": {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    flex: 1,
  },

  "& .sticky-day-headers": {
    position: "sticky",
    top: 0,
    display: "flex",
    flexDirection: "row",
    zIndex: 5,
  },
};

const allDayExpandContainer: CSSProperties = {
  width: 74,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingRight: 12,
  justifyContent: "flex-end",
  marginBottom: 12,
  backgroundColor: greys.palePaleGrey,
};

const allDayExpandDay: CSSProperties = {
  borderRadius: 2,
  fontFamily: fontFamilySans,
  fontSize: 12,
  cursor: "pointer",
  padding: "6px 8px",
  marginRight: 5,
  color: greys.slate,

  "&:hover": {
    backgroundColor: greys.paleGrey,
  },
};

const dayHeaderText: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderLeft: `1px solid ${greys.borderGrey}`,
  borderBottom: `1px solid ${greys.borderGrey}`,
  backgroundColor: greys.palePaleGrey,
  paddingBottom: 4,
  paddingTop: 12,

  "& .circle": {
    userSelect: "none",
    cursor: "pointer",
    borderRadius: "50%",
    width: 64,
    height: 64,
    marginBottom: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    "& .day-abbr": {
      fontFamily,
      color: colors.blueDusk.standard,
      fontSize: "12px",
      textTransform: "uppercase",
    },

    "& .day": {
      fontFamily,
      color: colors.blueDusk.standard,
      fontSize: "22px",
    },

    "&.today": {
      backgroundColor: colors.blueDusk.standard,

      "& .day-abbr, & .day": {
        color: greys.white,
      },
    },

    "&:hover": {
      backgroundColor: colors.blueDusk.lighter,

      "& .day-abbr, & .day": {
        color: greys.white,
      },
    },
  },

  "&:last-child": {
    borderRight: `1px solid ${greys.borderGrey}`,
  },
};

const dayContainer: CSSProperties = {
  flex: 1,
  borderRight: `1px solid ${greys.borderGrey}`,
};

const horizontalGridContainer: CSSProperties = {
  position: "absolute",
  width: "100%",
  height: "100%",
};

const horizontalGrid: CSSProperties = {
  position: "absolute",
  borderBottom: `1px solid ${greys.borderGrey}`,
  right: 0,
  left: 60,
};

export const styles = {
  container,
  dayHeaderText,
  dayContainer,
  horizontalGridContainer,
  horizontalGrid,
  allDayExpandContainer,
  allDayExpandDay,
};
